<template>
  <global-modal
    class="event-modal-edit-equipment-letter__wrap"
    name="event-modal-edit-equipment-letter"
    @before-open="beforeOpen"
  >
    <Modal
      v-if="letter"
      back
      mini
      @close="$modal.hide('event-modal-edit-equipment-letter')"
    >
      <EventModalEquipmentLetters
        edit-only
        :participant-id="participantId"
        :stands="stands"
        :edit-letter="letter"
        @saved="saved"
      />
    </Modal>
  </global-modal>
</template>

<script>
import Modal from "@/components/Modal/Modal.vue";
import EventModalEquipmentLetters from "./EventModalEquipmentLetters.vue";

export default {
  name: "EventModalEditEquipmentLetter",
  components: {
    EventModalEquipmentLetters,
    Modal
  },
  data() {
    return {
      participantId: 0,
      stands: [],
      letter: null,
      onSaved: null
    };
  },
  methods: {
    beforeOpen({ params }) {
      this.participantId = params.participantId;
      this.stands = params.stands;
      this.letter = params.letter;
      this.onSaved = params.onSaved;
    },
    saved() {
      if (this.onSaved) this.onSaved();
      this.$modal.hide("event-modal-edit-equipment-letter");
    }
  }
};
</script>

<style lang="scss" scoped>
.event-modal-edit-equipment-letter__wrap {
  position: relative;
  z-index: 20;
}
</style>
